@if (activatedContext) {
  <topo-modal
    [isActive]="activatedContext"
    [backgroundCanClose]="false"
    [rawWidth]="'90vw'"
    [rawHeight]="'80vh'"
    [isCard]="true"
    (close)="cancelClick()">
    <div class="modal-header">
      <div
        fxLayout="row"
        fxLayoutAlign="space-between center">
        <h5 class="mx-4 my-4">
          {{ dialogLabel }}
        </h5>
        <div
          class="dialog-close"
          (click)="cancelClick()">
          <i class="icon icon-close-X"></i>
        </div>
      </div>
    </div>
    <div class="modal-body">
      <div style="position: relative">
        <div class="recipient-list-page">
          <div class="data-table">
            <topo-data-table-server
              #table
              [isActive]="true"
              [datasource]="datasource"
              [columns]="columnDefs"
              [showHeader]="false"
              [headerLabel]="headerLabel"
              [showRowGroups]="false"
              [embedded]="true"
              [rawHeight]="tableHeight"
              [rowHeight]="56"
              [getRowId]="getRowId"
              [autoFitColumns]="true"
              [tabs]="tableTabs"
              [selectedTab]="activatedContext.uId"
              [headerIcon]="headerIcon"
              [showNewButton]="false"
              [showHeader]="true"
              [showSearch]="true"
              [showMenu]="false"
              [showRowGroups]="false"
              [showSystemFields]="true"
              [enableInfiniteScroll]="true"
              [enableServerSort]="false"
              (paginate)="onPaginate($event)"
              (takeChanged)="onTakeChanged($event)"
              (rowSelected)="onRowSelected($event)"
              (searchFilterChanged)="onSearchFilterChanged($event)"
              (storeUpdatedCalled)="onGridDataLoaded()"
              [skip]="skip"
              [take]="take"
            [totalCount]="totalCount"></topo-data-table-server>
          </div>
        </div>
        <div
          [ngClass]="{ 'select-checkbox': tableTabs?.length <= 1, 'select-checkbox-tabs': tableTabs?.length > 1 }">
          <topo-checkbox
            [checked]="allSelected"
            [indeterminate]="hasNotSelected"
          (checkChanged)="onSelectUnselectAll()"></topo-checkbox>
        </div>
        <div
          class="selected-section">
          <div class="selected-text">{{ 'COMMUNICATIONS.TOTAL-SELECTED' | translate : { number: getSelectedCount() } }}</div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <div
        fxLayout="row"
        fxLayoutAlign="space-between center"
        class="mt-4 mb-4">
        <div></div>
        <div fxLayoutAlign="start">
          <div style="margin-right: 5px">
            <button
              class="button is-secondary"
              (click)="cancelClick()">
              {{ 'COMMUNICATIONS.BUTTONS.CLOSE' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </topo-modal>
}
